import servicesUtils from "../../../utils/servicesUtils";
var getPatientDetails = function getPatientDetails(patientUid) {
  return servicesUtils.getService("/patients/".concat(patientUid, "/"), {
    stopRedirectLogin: true
  });
};
export default getPatientDetails;